import Field from "@/components/Field";
import { isRequired } from "@/lib/form";
import ProjectRoleSelect from "@/modules/projects/components/ProjectRoleSelect";
import ProjectStoreSelect from "@/modules/projects/components/ProjectStoreSelect";
import { writeRoleBasedAssignments } from "@/schemas/roleBasedAssignments";
import { useTranslation } from "react-i18next";

const schema = writeRoleBasedAssignments;

interface ContractorsAssignmentsProjectRoleBasedFieldsProps {
  projectId: string;
}

export const ContractorsAssignmentsProjectRoleBasedFields = ({
  projectId,
}: ContractorsAssignmentsProjectRoleBasedFieldsProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Field
        name="store_id"
        label={t("contractorsAssignments.fields.store_id")}
        required={isRequired(schema.shape.store_id)}
        render={({ field }) => (
          <ProjectStoreSelect
            {...field}
            className="w-80"
            projectId={projectId}
            inDialog
          />
        )}
      />
      <Field
        name="project_role_id"
        label={t("contractorsAssignments.fields.project_role_id")}
        required={
          "project_role_id" in schema.shape &&
          isRequired(schema.shape.project_role_id)
        }
        render={({ field }) => (
          <ProjectRoleSelect
            {...field}
            className="w-80"
            projectId={projectId}
            inDialog
          />
        )}
      />
    </>
  );
};
